import type { NextPage } from "next";
import { useEffect, useState } from "react";
import EventListBar from "../components/EventListBar";
import Layout from "../components/Layout";
import Spinner from "../components/Spinner";
import TimesheetEventDate from "../components/TimesheetEventDate";
import useStore from "../store/store";
import { IAllocation } from "../types/allocation";

const TimesheetPage: NextPage = () => {
  const { activeEvent, dataLoaded } = useStore();

  if (!dataLoaded) {
    return (
      <Layout currentPage="timesheet">
        <Spinner></Spinner>
      </Layout>
    );
  }

  return (
    <Layout currentPage="timesheet">
      <div className="flex  min-h-[calc(100%-72px)]">
        <div className="flex-1">
          <EventListBar></EventListBar>
          {activeEvent && (
            <>
              <TimesheetEventDate></TimesheetEventDate>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default TimesheetPage;
